import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { GoodsType, TruckLoadingType } from '../../hub/constants';
import { ListQueryParam, MINUTES_VALIDATORS, INTEGER_NUMBER_PATTERN, TruckSize } from '../../../../../common/constants';
import { TruckSizeMappingForm, TruckSizeMappingModel } from './truck-size-mapping.model';
import { DockType } from '../constants';
import { mustNotBeBlankValidator } from '../../../../../common/utils';

export interface DockItemURIParams {
  dockId: number;
  compartmentId: number;
  hubId: number;
}

export interface DockListURIParams {
  compartmentId: number;
  hubId: number;
  searchCriteria: DockListSearchCriteria;
}

export class DockBrief {
  id?: number;
  compartmentId?: number;
  active: boolean;
  name: string;
  overbooking: number;
  callToDockOverbooking: number;
  dockTypes: DockType[] = [];
  goodsTypes: GoodsType[] = [];
  loadingTypes: TruckLoadingType[] = [];
  truckSizeMappings: TruckSizeMappingModel[] = [];
  minServiceTime: number;
  maxServiceTime = 300;

  constructor(params?: DockBrief) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DockOverview extends DockBrief {
  location: string;
  additionalInformation: string;
  changeoverTime = 0;
  overbooking = 0;
  callToDockOverbooking = 0;

  constructor(params?: DockOverview) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DockOverviewForm {
  constructor(
    fb: UntypedFormBuilder,
    model: DockOverview,
    public id: ControlProperty<number> = model.id,
    public name: ControlProperty<string> = [model.name, [Validators.required, mustNotBeBlankValidator]],
    public location: ControlProperty<string> = model.location,
    public additionalInformation: ControlProperty<string> = model.additionalInformation,
    public active: ControlProperty<boolean> = model.active,
    public dockTypes: ControlProperty<DockType[]> = [model.dockTypes, [Validators.required]],
    public loadingTypes: ControlProperty<TruckLoadingType[]> = [model.loadingTypes, [Validators.required]],
    public goodsTypes: ControlProperty<GoodsType[]> = [model.goodsTypes, []],
    public overbooking: ControlProperty<number> = [model.overbooking, MINUTES_VALIDATORS],
    public callToDockOverbooking: ControlProperty<number> = [model.callToDockOverbooking, MINUTES_VALIDATORS],
    public changeoverTime: ControlProperty<number> = [model.changeoverTime, MINUTES_VALIDATORS],
    public minServiceTime: ControlProperty<number> = [
      model.minServiceTime,
      [Validators.pattern(INTEGER_NUMBER_PATTERN), Validators.min(1), Validators.required],
    ],
    public maxServiceTime: ControlProperty<number> = [model.maxServiceTime, MINUTES_VALIDATORS],
    public truckSizeMappings: UntypedFormArray = fb.array([]),
    public selectedTruckSizes: ControlProperty<TruckSize[]> = [
      model.truckSizeMappings?.map((item: TruckSizeMappingModel) => item.size),
      [Validators.required],
    ],
  ) {
    model.truckSizeMappings.forEach((item: TruckSizeMappingModel) => {
      this.truckSizeMappings.push(fb.group(new TruckSizeMappingForm(new TruckSizeMappingModel(item))));
    });
  }
}

export class DockListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: DockListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
